import axios from 'axios';

const getMetabaseDashboard = data => axios.post('/metabase', data);

export default {
  getMetabaseDashboard,
};
